import { OMKEntry, OMKResult } from '../../types/address';
import { OMKError } from '../errors/OMK';
import { OMK_SPECIAL_CASE } from '../constants/omkSpecialCases';
import { ZEL_OMK_STREET_CODE } from '../constants/address';

interface OMKToSubmit {
  omk_district_code: string;
  omk_area_code: string;
  omk_street_code: string;
}

function getCodes(
  array: OMKEntry[],
  specialCase?: 'zelao' | 'newMoscow' | 'manualInput'
) {
  return array.reduce<{
    omk_area_code: string | null;
    omk_district_code: string | null;
    omk_street_code?: string;
  }>(
    (acc, curr) => {
      const { territorial_units, territories } = curr;
      const omk_area_code = territorial_units[0]?.omk_area_code;
      const omk_district_code = territorial_units[0]?.omk_district_code;
      const [tm_code] = territories;
      const omk_tm_code = tm_code ? tm_code.substring(1) : '';
      let { omk_street_code } = curr;

      if (specialCase === OMK_SPECIAL_CASE.zelao && !omk_street_code) {
        omk_street_code = ZEL_OMK_STREET_CODE;
      }
      if (specialCase !== OMK_SPECIAL_CASE.manualInput && !omk_street_code) {
        omk_street_code = omk_tm_code;
      }

      acc.omk_area_code = omk_area_code ?? acc.omk_area_code;
      acc.omk_district_code = omk_district_code ?? acc.omk_district_code;
      acc.omk_street_code = omk_street_code ?? acc.omk_street_code;

      return acc;
    },
    { omk_area_code: null, omk_district_code: null }
  );
}

export function parseOMKResponse(response: OMKResult): OMKToSubmit;
export function parseOMKResponse(
  response: OMKResult,
  specialCase: 'zelao'
): OMKToSubmit;
export function parseOMKResponse(
  response: OMKResult,
  specialCase: 'newMoscow' | 'manualInput'
): Partial<OMKToSubmit>;

/**
 * @throws {OMKError} Если меньше одного результата
 * @throws {OMKError} Если отсутствует хотя бы один код и это не ТиНАО
 */
export function parseOMKResponse(response, specialCase?) {
  if (response.data.length < 1) {
    throw new OMKError(
      `Некорректное количество записей: ожидалось как минимум 1, получено ${response.data.length}`
    );
  }

  const { omk_area_code, omk_district_code, omk_street_code } = getCodes(
    response.data,
    specialCase
  );
  const valid = (specialCase === OMK_SPECIAL_CASE.newMoscow
    ? [omk_area_code, omk_district_code]
    : [omk_area_code, omk_district_code, omk_street_code]
  ).every(Boolean);
  if (!valid) {
    throw new OMKError('Отсутствует по крайней мере один код для адреса');
  }
  return {
    omk_district_code,
    omk_area_code,
    omk_street_code,
  } as OMKToSubmit | Partial<OMKToSubmit>;
}
